<app-modal titleId="charge-details" (close)="close.emit()">
  <header class="bg-[#eeeeee] p-6">
    <span class="text-neutral-600 text-2xl font-['Inter'] leading-normal">
      Detalle del cobro
    </span>
  </header>
  <hr class="border-t-[1px] border-t-neutral-200" />

  <div class="flex flex-col p-6 overflow-x-hidden overflow-y-auto gap-4 text-neutral-600 font-['Inter'] leading-normal">
    <section class="flex flex-col border rounded-lg border-[#bebebe]">
      <span class="p-4 border-b-[1px] border-[#bebebe] font-semibold text-base">
        Información principal
      </span>
      <section class="p-4 grid grid-cols-[110px_auto] gap-2 text-xs">
        <span class="font-semibold">
          ID de cobro:
        </span>
        <span>
          {{charge.order_number}}
        </span>
        <span class="font-semibold">
          Fecha/Hora
        </span>
        <span>
          {{ charge.date | date:'dd/MM/yyyy HH:mm' }}
        </span>
        <span class="font-semibold">
          Monto
        </span>
        <span>
          {{ charge.amount | currencyClp }}
        </span>
        <span class="font-semibold">
          Tipo de cobro
        </span>
        <span>
          {{ charge.type }}
        </span>
        <span class="font-semibold">
          Estado
        </span>
        <span>
          <app-badge [variant]="getVariant(charge)">
            {{ charge.status }}
          </app-badge>
        </span>
      </section>
    </section>

    <section class="flex flex-col border rounded-lg border-[#bebebe]">
      <span class="p-4 border-b-[1px] border-[#bebebe] font-semibold text-base">
        Desglose de ítems
      </span>
      <section class="text-xs gap-8">
        <div class="grid grid-cols-3 text-center py-3 border-b-[1px] border-[#bebebe] font-semibold">
          <span>Documento de referencia</span>
          <span>Descripción</span>
          <span>Monto</span>
        </div>

        @for(item of charge.items; track $index ) {
          <div class="grid grid-cols-3 text-center py-3 border-b-[1px] border-[#bebebe]">
            <span>
              <span class="mr-1">{{ item.documentType | docTypeLabel }}</span>
              <span>{{ item.documentNumber }}</span>
            </span>
            <span>
              {{ item.description }}
            </span>
            <span>
              {{ item.amount | currencyClp }}
            </span>
          </div>
        }

        <div class="grid grid-cols-3 text-center py-3 font-semibold">
          <span></span>
          <span>Total del cobro</span>
          <span>
            {{ charge.amount | currencyClp }}
          </span>
        </div>

      </section>
    </section>
  </div>

  <footer class="flex justify-between gap-3 p-6 border-t-[1px] border-t-neutral-200" modal-footer>
    <button type="button" class="flex h-10 text-xs font-['Inter'] font-semibold items-center gap-2 text-indigo-500 disabled:cursor-not-allowed" (click)="generatePDF()" [disabled]="generatingPdf()">
      <img class="w-6 h-6" src="../../../assets/img/charges/ic-download-indigo.svg" />
      Descargar comprobante
      @if(generatingPdf()) {
        <div class="loader"></div>
      }
    </button>
    <button type="button" class="button-footer bg-indigo-500 text-white hover:bg-indigo-600 disabled:bg-neutral-400" (click)="close.emit()"> 
      Cerrar
    </button>
  </footer>
</app-modal>